import { LoadingSkeleton } from 'sonata-react-components';

import { GroupSkeletonStyled } from './GroupSkeleton.styled';

function GroupSkeleton() {
  return (
    <GroupSkeletonStyled className="groupSkeleton">
      {Array.from({ length: 1 }).map((_, groupIndex) => (
        <div className="groupSkeleton__groupCard" key={groupIndex}>
          <div className="groupSkeleton__groupHeader">
            <LoadingSkeleton height={16} width={120} />
            <LoadingSkeleton height={28} width={120} />
          </div>
          {Array.from({ length: 1 }).map((__unused, itemIndex) => (
            <div className="groupSkeleton__groupItem" key={itemIndex}>
              <div className="groupSkeleton__groupItem--left">
                <LoadingSkeleton height={14} width={80} /> <LoadingSkeleton height={12} width={100} />{' '}
                <LoadingSkeleton height={12} width={60} />{' '}
              </div>
              <div className="groupSkeleton__groupItem--right">
                <LoadingSkeleton height={12} width={40} /> <LoadingSkeleton height={12} width={80} />{' '}
              </div>
            </div>
          ))}
          <div className="groupSkeleton__deleteButton">
            <LoadingSkeleton height={32} width="100%" />{' '}
          </div>
        </div>
      ))}
    </GroupSkeletonStyled>
  );
}

export default GroupSkeleton;
